import { useRouter } from 'next/router';
import { t } from 'i18next';
// contexts
import { useModalMissingDocsContext } from 'context/ModalMissingDocs/ModalMissingDocs-context';
// components
import { ExButton } from '@commons/EXComponentsLibrary';
import { Modal } from 'rsuite';
import { Icon } from './Icon';
// utils && hooks
import { useUser } from 'utils/hooks';
// styles
import styles from './ModalIncompleteDocs.module.css';

const ModalIncompleteDocs = () => {
    const { hasAuthorization } = useUser({});
    const { openModalMissingDocs, setOpenModalMissingDocs } = useModalMissingDocsContext();
    const router = useRouter();

    const handleRedirect = () => {
        if (router.query.clientId && router.query.posId) {
            setOpenModalMissingDocs(false);
            const url = hasAuthorization
                ? `/pos/${router.query.clientId}/${router.query.posId}#documentation`
                : `/${router.query.clientId}/settings/POS/${router.query.posId}/posDetails#documentation`;
            setTimeout(() => {
                router.push(url);
            }, 1000);
        }
    };

    return (
        <Modal
            backdrop={true}
            open={openModalMissingDocs}
            onClose={() => setOpenModalMissingDocs(false)}
            className={styles['container']}
        >
            <Modal.Header className={styles['header']}>
                <div className={styles['img']}>
                    <Icon />
                </div>
                <Modal.Title className={styles['title']}>{t('documentation.modal.title')}</Modal.Title>
            </Modal.Header>

            <Modal.Body className={styles['body']}>
                <p>{t('documentation.modal.body')}</p>
            </Modal.Body>
            <Modal.Footer className={styles['footer']}>
                <ExButton appearance="primary" onClick={() => handleRedirect()} fullWidth>
                    {t('documentation.modal.button_load')}
                </ExButton>
                <ExButton appearance="ghost" onClick={() => setOpenModalMissingDocs(false)}>
                    {t('documentation.modal.button_discard')}
                </ExButton>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalIncompleteDocs;
